import { Component, DestroyRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CaButtonComponent } from '@global-front-components/ui/button';

@Component({
	selector: 'app-pymes-objeciones-ventas',
	standalone: true,
	imports: [CommonModule, CaButtonComponent, TranslateModule],
	templateUrl: './pymes-objeciones-ventas.component.html',
	styleUrls: ['./pymes-objeciones-ventas.component.scss']
})
export class PymesObjecionesVentasComponent {

	title: string = '';
	questions: any[] = [];
	questionRows: any[] = [];

	constructor(
		private translateService: TranslateService,
		private destroyRef: DestroyRef
	) { }

	ngOnInit(): void {
		this.loadQuestionsFromTranslations();
	}

	private loadQuestionsFromTranslations(): void {
		this.translateService
			.stream('PYMES.OBJECIONES-VENTAS')
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe((data: any) => {
				this.title = data?.TITLE || '';
				this.questions = data?.QUESTIONS || [];
				this.questionRows = this.buildQuestionRows(this.questions);
			});
	}

	private buildQuestionRows(questions: any[]): any[] {
		const half = Math.ceil(questions.length / 2);
		const leftColumn = questions.slice(0, half);
		const rightColumn = questions.slice(half);

		return leftColumn.map((leftQuestion, index) => ({
			left: leftQuestion,
			right: rightColumn[index] || null
		}));
	}

	trackByRow(index: number): number {
		return index;
	}

	trackByBullet(index: number, bullet: string): string {
		return bullet;
	}

}
